export default {
    APP_CLASSNAME: 'ica',
    COMPONENTS_CONTAINER_CLASS_NAME: 'ica-components-wrapper',
    PROFILE_SIDEBAR_CONTENT: 'profile-sidebar-content',
    STICKY_HEADER_HEIGHT_VARIABLE: '--sticky-header-height',
};
